import { render, staticRenderFns } from "./message-history.vue?vue&type=template&id=7d74b40e&scoped=true"
import script from "./message-history.vue?vue&type=script&lang=js"
export * from "./message-history.vue?vue&type=script&lang=js"
import style0 from "./message-history.vue?vue&type=style&index=0&id=7d74b40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74b40e",
  null
  
)

export default component.exports